<template>
    <div>
      <common-dialog ref="dialog" width="750px" show-save-button unit="批量修改" edit-title id-key="RecordId" :data="data"
        form-label-width="105px"  :save-func="() => { }"
        close-on-saved :before-save="onBeforeSave" @closed="onClosed" @close-saved="$emit('close-saved')">
        <template slot="form">
          <el-row>
            <el-col :span="isMB?24:12">
             <!-- <el-form-item label="板块名称" prop="SectionId">
                <el-select v-model="data.SectionId" placeholder="请选择板块名称" clearable>
                  <el-option v-for="item in listbk" :key="item.RecordId" :value="item.RecordId" :label="item.SectionName"></el-option>
                </el-select>
              </el-form-item> -->
             
              
              <el-form-item >
                <template slot="label">
                    <el-checkbox v-model="data.XnxlChecked"></el-checkbox>
                虚拟销量
                </template>
                 <el-input v-model="data.VirtuallySales" placeholder="请输入虚拟销量" :disabled="data.XnxlChecked==false" style="width:95%;" ></el-input>   <!--:disabled="true"为不可用状态，必须加上：号才是布尔值，否则就变成字符串-->
              </el-form-item>
            </el-col>
  
            <el-col :span="isMB?24:12">
                
              <el-form-item >
                <template slot="label">
                    <el-checkbox v-model="data.XnlllChecked"></el-checkbox>
                虚拟浏览量
                </template>
                 <el-input v-model="data.VirtuallyBrowse" placeholder="请输入虚拟浏览量" :disabled="data.XnlllChecked==false" style="width:95%;"></el-input>   
              </el-form-item>
            </el-col>
          </el-row>
  
          <el-row>
            <el-col :span="isMB?24:12">
                <el-form-item >
                <template slot="label">
                    <el-checkbox v-model="data.XsfwChecked"></el-checkbox>
                销售范围
                </template>
                 <el-input v-model="data.SaleRange" placeholder="请输入销售范围" :disabled="data.XsfwChecked==false" style="width:95%;"></el-input>   
              </el-form-item>
            </el-col>
            <el-col :span="isMB?24:12">
                <el-form-item >
                <template slot="label">
                    <el-checkbox v-model="data.ThhsmChecked"></el-checkbox>
                退换货说明
                </template>
                 <el-input v-model="data.ReturnIllustrate" placeholder="请输入退换货说明" :disabled="data.ThhsmChecked==false" style="width:95%;"></el-input>   
              </el-form-item>
            </el-col>

  
         </el-row>
          
  
        </template>
      </common-dialog>
    </div>
  </template>
    <script>
  import editDialogMixin from "@/mixins/editDialog";
  import commonDialog from "@/components/common/dialog";
 
  export default {
    mixins: [editDialogMixin],
    components: {
      commonDialog,
 
    },
    data() {
      return {
        isMB: this.$store.state.isMB,
        data: {
            XnxlChecked: false,  //默认不选中,为false
            XnlllChecked: false,
            XsfwChecked: false,
            ThhsmChecked: false,
            VirtuallySales:null,
            VirtuallyBrowse:null,
            SaleRange:"",
            ReturnIllustrate:"",
            RecordIds:null,
          },
          api: require("@/api/goods/info").default,      
      };
    },
    mounted(){
     
    },
    methods: {
      getData(Ids) {
           this.data.RecordIds=Ids;   //将上架列表页面传过来的选中行的id的集合赋值给本界面的RecordIds
       
      },
      onBeforeSave() {
       if (this.data.XnxlChecked==true) {
            if ((this.data.VirtuallySales=="")||(this.data.VirtuallySales==null)) {
                this.$message.error("虚拟销量不能为空");
                 return false;
            }
      } 
      
      if (this.data.XnlllChecked==true) {
            if ((this.data.VirtuallyBrowse=="")||(this.data.VirtuallyBrowse==null)) {
                this.$message.error("虚拟浏览量不能为空");
                 return false;
            }
      } 

      if (this.data.XsfwChecked==true) {
            if ((this.data.SaleRange=="")||(this.data.SaleRange==null)) {
                this.$message.error("销售范围不能为空");
                 return false;
            }
      } 

      if (this.data.ThhsmChecked==true) {
            if ((this.data.ReturnIllustrate=="")||(this.data.ReturnIllustrate==null)) {
                this.$message.error("退换货说明不能为空");
                 return false;
            }
      } 
      var data = JSON.parse(JSON.stringify(this.data)); //调用保存接口之前将数据json化
      data = this.$commonJs.obj.removeNullKey(data);      //调用保存接口之前固定这两句
      this.loading();
      this.api.updateBatchGoods(data).then(res => {
        this.loading(false);
        if (res.Code == 0) {
          this.$message.success(res.Msg);
          this.close(true);
          this.$emit('close-saved');
        } else {
          this.$message.error(res.Msg);
        }
      })
      return false;
        
      },
      onClosed() {
       
      },
    },
  };
</script>